import {
  $applyNodeReplacement,
  DOMConversionOutput,
  ElementFormatType,
  LexicalNode,
  setNodeIndentFromDOM,
} from 'lexical';

import { ReferenceNode } from './ReferenceNode';

export const $createReferenceNode = (): ReferenceNode => {
  return $applyNodeReplacement(new ReferenceNode());
};

export const $isReferenceNode = (
  node: LexicalNode | null | undefined,
): node is ReferenceNode => {
  return node instanceof ReferenceNode;
};

export const $convertReferenceElement = (
  element: HTMLElement,
): DOMConversionOutput => {
  const node = $createReferenceNode();
  if (element.style) {
    node.setFormat(element.style.textAlign as ElementFormatType);
    setNodeIndentFromDOM(element, node);
  }
  return { node };
};
